/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TAddVacancyModel,
  IAddVacancyRequest,
  IMappers,
  IAddVacancyResponse,
  IAddVacancyResponseError,
  TAddVacancyResponse,
} from './types';

const defaultConfig: TAddVacancyModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'vacancies',
  pathApi: '/v1/add-vacancy/',
  hostType: 'ud-api',
} as TAddVacancyModel;

function createAddVacancyModel(parameters: IAddVacancyRequest): TAddVacancyModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAddVacancyOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IAddVacancyRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchAddVacancy<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IAddVacancyOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TAddVacancyResponse> {
  const { response, statusCode } = await httpApi.fetch(createAddVacancyModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddVacancyResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IAddVacancyResponseError);
    }
  }

  return { response, statusCode } as TAddVacancyResponse;
}

export { defaultConfig, createAddVacancyModel, fetchAddVacancy };
